

export default {
    name: "win-mixins",
    data: function () {

    },
    computed: {

    },
    props: {
        showLoading: { type: Boolean, default: false },
        footerBar: { type: Boolean, default: true },
        continueBtn: { type: Boolean, default: false },
        confirmBtn: { type: Boolean, default: true },
        height: { type: [String, Number], default: 400 },
        width: { type: [String, Number], default: 450 },
        title: { type: String, default: "" },
        value: {}
    },
    methods: {

    },
    mounted() {
    },
    components: {}
};



// WEBPACK FOOTER //
// ./goingsrc/vueCom/ctlMixins/WinMixins.js